import script from "./devotion-info.vue?vue&type=script&setup=true&lang=js"
export * from "./devotion-info.vue?vue&type=script&setup=true&lang=js"

import "./devotion-info.vue?vue&type=style&index=0&id=2ea107e6&lang=css"

const __exports__ = script;

export default __exports__